import { Pipe, PipeTransform } from '@angular/core';

import { contrastColor } from './color-utils';
import { DEFAULT_COLOR_CONTRAST_VALUES } from './constants';
import { ContrastColorValues } from './types';

@Pipe({
  name: 'contrastColor',
})
export class ContrastColorPipe implements PipeTransform {
  private readonly defaultContrastValues = DEFAULT_COLOR_CONTRAST_VALUES;

  public transform(
    color: string,
    contrastValues?: Partial<ContrastColorValues>,
  ): string {
    return contrastColor(color, {
      ...this.defaultContrastValues,
      ...contrastValues,
    });
  }
}
@Pipe({
  name: 'preserveContrastColor',
})
export class PreserveContrastColorPipe implements PipeTransform {
  private readonly defaultContrastValues = DEFAULT_COLOR_CONTRAST_VALUES;

  /** Return color if it satisfies contrast constraints.
   * Otherwise, return black.
   * Custom contrast configuration arguments allowed. */
  public transform(
    color: string,
    contrastValues?: Partial<Omit<ContrastColorValues, 'highContrastReturn'>>,
  ): string {
    return contrastColor(color, {
      ...this.defaultContrastValues,
      ...contrastValues,
      highContrastReturn: color,
    });
  }
}
